import { NgModule } from '@angular/core';
import { ComposablesModule } from '@legacy/common-ui-common-renderings';
import { DeployUrlPipe } from '@innogy/utils/environment';
import { ReviewScoreComponent } from '@reviews/ui/score';
import { ReviewSingleComponent } from '@reviews/ui/single';
import { ReviewStarsComponent } from '@reviews/ui/stars';
import { CommonModule } from '@angular/common';
import { AnalyticsModule } from '@analytics/core';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { CoreJssProxyModule } from '@core/jss-proxy';

import { ReviewEntryContainerComponent } from './review-entry/review-entry-container.component';
import { ReviewOverviewContainerComponent } from './review-overview/review-overview-container.component';
import { ReviewScoreContainerComponent } from './review-score/review-score-container.component';
import { ReviewSingleContainerComponent } from './review-single/review-single-container.component';

const exportComponents = [
  ReviewScoreContainerComponent,
  ReviewSingleContainerComponent,
  ReviewEntryContainerComponent,
  ReviewOverviewContainerComponent,
];

@NgModule({
  imports: [
    CommonModule,
    AnalyticsModule,
    ComposablesModule,
    DeployUrlPipe,
    ReviewScoreComponent,
    ReviewSingleComponent,
    ReviewStarsComponent,
    CoreJssProxyModule,
    AutomationIdDirective,
  ],
  declarations: [...exportComponents],
  exports: exportComponents,
})
export class ReviewsLegacyModule {}
